import { useEffect, useState } from "react"
import icClosePopup from "../../assets/images/ic-close-popup.svg";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
  
export const TabbedPanelE10x = ({tabs, onTabChange = () => {}, defaultTab, removeTabAction=false}) => {
    const [currentTab, setCurrentTab] = useState(0);
    const changeTab = (tab, tabIndex) => {
        setCurrentTab(tabIndex);
        onTabChange(tab);
    }
    useEffect(()=>{
        if (defaultTab || defaultTab==0){
            setCurrentTab(defaultTab)
        }
    },[defaultTab]);

    const disabledCss = "cursor-not-allowed whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm";
    const truncate = (passedString, n) => {
    return passedString.length > n
        ? passedString.slice(0, n - 1) + ".."
        : passedString;
    };

    return (
        <div>
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                Select a tab
                </label>
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select
                id="tabs"
                name="tabs"
                onChange={changeTab}
                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-[#d15555] focus:outline-none focus:ring-[#d15555] sm:text-sm"
                defaultValue={tabs[currentTab]}
                >
                {tabs.map((tab) => (
                    <option key={tab.title}>{tab.title}</option>
                ))}
                </select>
            </div>
            <div className="hidden sm:block">
                <div className="">
                    <nav className="-mb-px flex gap-1" aria-label="Tabs">
                        {tabs.map((tab, tabIndex) => {
                            return (
                            <div className={`relative border border-stone-200 bg-stone-50 whitespace-nowrap py-2 ${removeTabAction ? ' pr-4' : ' pr-0'}`}>
                                <a
                                    key={tab.title}
                                    id={`${tabIndex}_${tab.slug}`}
                                    title={tab.title}
                                    href={tab.href}
                                    onClick={() => !tab.disabled && changeTab(tab, tabIndex)}
                                    className={classNames(
                                    tabIndex == currentTab
                                        ? 'bg-stone-50 border-b-[#74abb1] border-b-2 text-teal-c-900 font-bold	'
                                        : 'bg-stone-50 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-light ',
                                    'whitespace-nowrap text-sm py-[0.5rem] px-[0.5rem] cursor-pointer'
                                    )}
                                    aria-current={tabIndex == currentTab ? 'page' : undefined}
                                >
                                    {truncate(tab.title, 30)}
                                    {tab?.sub_title && <span className={tab?.sub_title_cls}>{tab?.sub_title}</span>}
                                </a>
                                {removeTabAction && <a className="cursor-pointer absolute right-[-0.5rem] top-[0.1rem] p-[0.9rem]" onClick={()=>{
                                    removeTabAction(tab);
                                }}>
                                    <img src={icClosePopup} className="w-[10px]" />
                                </a>}
                            </div>
                        )})}
                    </nav>
                </div>
            </div>
        </div>
    )
}
